import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-acceleration-speed',
  templateUrl: './acceleration-speed.component.html',
  styleUrl: './acceleration-speed.component.css'
})
export class AccelerationSpeedComponent implements OnChanges {

  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  @Input() widgetType: string;

  public lineChartData: any = {};

  ngOnChanges(): void {
    this.lineChartData = {
      xAxis: {
        type: 'category',
        data: [1, 2, 3, 4, 5, 6],
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false
        }
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: this.widgetType === "acceleration" ? [0,0,0,0,0,0] : [0,0,0,0,0,0],
          type: 'line',
          lineStyle: {
            color: '#32A7D0' 
          },
          itemStyle: {
            color: '#32A7D0' 
          },
          markLine: {
            data: [
              { yAxis: 8 },
              { yAxis: 4 }
            ],
            lineStyle: {
              type: 'solid',
              color: 'rgba(250, 174, 165, 1)',
              width: 1
            },
            symbol: 'none',
            label: {
              show: false
            }
          }
        }
      ],
      grid: {
        top: '10%',
        left: '8%',
        right: '5%',
        bottom: '8%'
      }
    }
  }

}
